import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Creation icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Creation } from '@sravni/design-system-icons'
 *
 * <Creation />
 * ```
 */
var Creation = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Creation", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m15.164 13.277 1.647 1.646a.931.931 0 0 1 0 1.317l-.989.988a.931.931 0 0 1-1.316 0l-1.647-1.646-1.24 1.24a.465.465 0 0 1-.771-.181L8.454 9.46a.466.466 0 0 1 .59-.59l7.18 2.394c.328.11.427.526.182.771l-1.242 1.242ZM3.983 9.108h-1.9M5.367 5.783l-1.35-1.35M5.333 12.467l-1.35 1.35M8.692 4.4V2.5M12.05 5.75 13.4 4.4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Creation };
//# sourceMappingURL=Creation.js.map
